import React, { Component } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import { loadingStatus, getPayload } from "../../actions"
import fieldStatus from "../../helpers/fieldStatus"
import submitData from "../../helpers/submitData"
import { Formik, Field, Form } from "formik"
import * as Yup from "yup"
import { Redirect } from "react-router-dom"
import Title from "../general/title"

class AddISD extends Component {
    constructor(props) {
        super(props)
        this.state = {
            ready: false,
            modal: false,
            fields: {
				name: '',
				code: ''
			},
        }
    }

    validation = () => {
        return Yup.object().shape({
            name: Yup.string().required("Required"),
            code: Yup.string().required("Required"),
        })
    }

    submitClasses = f => {
        var classNames = require("classnames")
        var submitClasses = classNames("form__submit", {
            "form__submit--ready": f,
        })

        return submitClasses
    }


    render() {
        if (!this.props.payloadStatus) {
			return ""
		} else if (this.state.redirect) {
			return <Redirect to={this.state.redirectPath} />
		} else {
			return (
				<div>
					<Title title="Add ISD" showDate={false} />
					<div className="content">
						<h3 />
						<Formik
							enableReinitialize
							initialValues={this.state.fields}
							validationSchema={this.validation}
							validateOnMount={true}
							onSubmit={(values) => {
								this.props.loadingStatus(true)
								submitData("inputISD", values).then((data) => {
									this.props.loadingStatus(false)
									this.setState(
										{
											redirect: true,
											redirectPath: data.redirect,
										},
										() => {
											this.props.getPayload()
										}
									)
								})
							}}
							render={(f) => (
								<div className="addISD">
									<Form>
										<ul className="form__list">
											<li className={fieldStatus("name", f)}>
												<label htmlFor="name">
													Name <sup>*</sup>
												</label>
												{f.errors.name && f.touched.name && (
													<div className="form__message">{f.errors.name}</div>
												)}
												<Field name="name" type="text" className="form__input" />
											</li>
											<li className={fieldStatus("code", f)}>
												<label htmlFor="code">
													Code <sup>*</sup>
												</label>
												{f.errors.code && f.touched.code && (
													<div className="form__message">{f.errors.code}</div>
												)}
												<Field name="code" type="text" className="form__input" />
											</li>
										</ul>
										<input type="submit" value="Submit" className={this.submitClasses(f.isValid)} />
									</Form>
								</div>
							)}
						/>
					</div>
				</div>
			)
		}
    }
}

function mapStateToProps(state) {
    return {
        payload: state.payload,
        payloadStatus: state.payloadStatus
    }
}

function matchDispatchToProps(dispatch) {
    return bindActionCreators(
        {
			loadingStatus,
			getPayload
        },
        dispatch
    )
}

export default connect(
    mapStateToProps,
    matchDispatchToProps
)(AddISD)
